<div class="chantier-display user-select-none d-flex align-items-center justify-content-between" (click)="onChantierDisplayClicked($event)" role="button">
  <span class="chantier-display-text">{{selectedChantier?.displayName}}</span>
  <span *ngIf="selectableChantiers.length">
    <i *ngIf="!showOptions()" class="bi bi-caret-down-fill"></i>
    <i *ngIf="showOptions()" class="bi bi-caret-up-fill"></i>
  </span>
</div>
<div *ngIf="showOptions() && selectableChantiers.length" class="options">
  <div *ngFor="let chantier of selectableChantiers" (click)="onChantierSelected(chantier.code)" class="option" role="button">
    {{chantier.displayName}}
  </div>
</div>
